module.exports = __webpack_public_path__ + "img/1.2fcd083c.png";